import React, { useEffect, useState, Fragment } from "react";
import { Form } from "react-bootstrap";
import { convertAccentedLettersToEnglish } from "../../../utils/utils";
import { useSelector } from "react-redux";
import "./GoogleAutoComplete.css";
import axios, { axiosBase } from "../../../service/axios";

const GoogleAutoComplete = (props) => {
  const apiKey = useSelector(
    ({ service }) => service.UI_ENV?.AUTOCOMPLETE_API_KEY
  );
  const { required, fieldId, fieldLabel, placeHolder, key } = props.field;
  const {
    onAutoCompleteChange,
    onSelectAddress,
    setFormValues,
    handleValidate,
    errors,
    disableFields,
    setCoordinates,
    pageFrom = "",
  } = props;
  const [inputValue, setInputValue] = useState({});

  useEffect(() => {
    const existingScript = document.getElementById("google_places");

    if (!existingScript) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&output=json&libraries=places`;
      script.id = "google_places";
      script.defer = true;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  useEffect(() => {
    inputValue[key] && autoCompleteAPI(key);
  }, [inputValue[key]]);

  const autoCompleteAPI = (addressType) => {
    if (!apiKey) return console.error("Autocomplete API Key does not exist!");
    mutationObserver();
    let input = document.getElementById(key);
    let autoComplete = new window.google.maps.places.Autocomplete(input);
    autoComplete.setComponentRestrictions({
      country: ["us", "ca"],
    });

    autoComplete.addListener("place_changed", () => {
      let place = autoComplete.getPlace();
      if (!place.geometry) {
        return;
      }
      extractAutoCompleteAddress(place, addressType);
      const { location } = place.geometry;
      let off_set = place.utc_offset_minutes;
      var tmstamp = Math.round((Date.now() + 1000 * 60 * off_set) / 1000);
      if (setCoordinates) {
        getTimezone(location.lat(), location.lng(), tmstamp);
      }
    });
  };

  const getTimezone = (lat, lng, tmstamp) => {
    axiosBase()
      .get(`/google/api/getTimeZone?lat=${lat}&lng=${lng}&timestamp=${tmstamp}`)
      .then(function(response) {
        tmstamp = response.data;
        setCoordinates(lat, lng, tmstamp);
      })
      .catch(function(error) {
        console.log(error);
      });
  };
  const mutationObserver = () => {
    const autocompleteInput = document.getElementById(key);

    let observerHack = new MutationObserver(function() {
      observerHack.disconnect();
      autocompleteInput.setAttribute("autocomplete", key);
    });

    observerHack.observe(autocompleteInput, {
      attributes: true,
    });
  };

  const onChange = (e, props) => {
    setInputValue({ [e.target.name]: e.target.value });
    onAutoCompleteChange(e, props);
  };

  const extractAutoCompleteAddress = (address, addressType) => {
    let streetAddress = "";
    let city = "";
    let zipCode = "";
    let state = "";
    let country = "";
    let currentAddressChange = {};
    let cityValues = {};

    const cityPriority = [
      "locality",
      "sublocality_level_1",
      "neighborhood",
      "administrative_area_level_3",
    ];

    for (let i = 0; i < address.address_components.length; i++) {
      if (address.address_components[i].types[0] === "street_number") {
        streetAddress = address.address_components[i].long_name;
      } else if (address.address_components[i].types[0] === "route") {
        streetAddress =
          streetAddress !== ""
            ? `${streetAddress} ${address.address_components[i].long_name}`
            : address.address_components[i].long_name;
      } else if (
        address.address_components[i].types[0] === "locality" ||
        address.address_components[i].types[0] === "sublocality_level_1" ||
        address.address_components[i].types[0] === "neighborhood" ||
        address.address_components[i].types[0] === "administrative_area_level_3"
      ) {
        cityValues = {
          ...cityValues,
          [address.address_components[i].types[0]]:
            address.address_components[i].short_name,
        };
      } else if (address.address_components[i].types[0] === "postal_code") {
        zipCode = address.address_components[i].short_name;
      } else if (
        address.address_components[i].types[0] === "administrative_area_level_1"
      ) {
        state = address.address_components[i].short_name;
      } else if (
        address.address_components[i].types[0] === "country" &&
        address.address_components[i].types[1] === "political"
      ) {
        country = address.address_components[i].short_name;
      }
    }

    for (let i = 0; i < cityPriority.length; i++) {
      city = cityValues[cityPriority[i]] && cityValues[cityPriority[i]];
      if (city) {
        break;
      }
    }

    streetAddress = convertAccentedLettersToEnglish(streetAddress);
    city = convertAccentedLettersToEnglish(city);

    currentAddressChange = { streetAddress, zipCode, state, country };
    if (pageFrom === "shippingLocation") {
      currentAddressChange.cityShipping = city;
    } else {
      currentAddressChange.city = city;
    }
    onSelectAddress(currentAddressChange, props);
  };

  return (
    <Fragment key={fieldId}>
      <Form.Label
        key={`${fieldId}Label`}
        id={`${fieldId}Label`}
        htmlFor={fieldId}
        style={{
          color: "black",
          fontWeight: props.addressFields ? "500" : "bold",
        }}
      >
        {fieldLabel}
        {required && <span className="required">*</span>}
      </Form.Label>
      <Form.Control
        key={`${key}_autoComplete`}
        id={key}
        name={key}
        placeholder={placeHolder}
        autoComplete={key}
        disabled={disableFields}
        type="text"
        onBlur={(e) =>
          handleValidate(
            {
              field: props.field,
              fieldValue: props.value,
            },
            setFormValues
          )
        }
        onChange={(e) => {
          () =>
            handleValidate(
              {
                field: props.field,
                fieldValue: props.value,
              },
              setFormValues
            );
          onChange(e, props);
        }}
        value={props.value}
      />
      {errors && errors[key] && (
        <div key={key} className="error" style={{ color: "#d64a4a" }}>
          {errors[key]}
        </div>
      )}
    </Fragment>
  );
};

export default GoogleAutoComplete;
